import { makeColumnPrefs } from '@/lib/tableColumnPrefs';

// 廃棄履歴 (Disposal History) テーブルのカラム設定。
export const DISPOSAL_COLUMN_DEFS = [
  { key: 'disposal_date', label: '廃棄日', defaultOn: true, fixed: true },
  { key: 'asset_type', label: '種類', defaultOn: true },
  { key: 'asset_name', label: '資産名', defaultOn: true },
  { key: 'asset_tag', label: 'タグ', defaultOn: true },
  { key: 'category', label: 'カテゴリ', defaultOn: true },
  { key: 'qty', label: '数量', defaultOn: true },
  { key: 'disposal_reason', label: '理由', defaultOn: true },
  { key: 'disposal_method', label: '方法', defaultOn: true },
  { key: 'disposed_by', label: '実施者', defaultOn: true },
];

export const disposalCols = makeColumnPrefs(DISPOSAL_COLUMN_DEFS, 'it_disposal_cols_v1');
